import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { Link } from "react-router-dom/cjs/react-router-dom"
import { Card } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import LanguagesTable from "../../components/tables/LanguagesTable"
import MaterialIcon from "../../components/elements/MaterialIcon"
import { getLanguagesAction } from "../../actions/languagesActions"

class LanguagePage extends Component {

	componentDidMount() {
		this.props.getLanguagesAction({ pageSize: 15, sorted: null, filters: [], page: 1 })
	}

	render() {
		return (
			<div>
				<div className="top-actions-row">
					<Link to="languages/create" className="btn btn-primary btn-sm btn-roundet btn-dropshadow"><MaterialIcon icon="add" /><FormattedMessage id="buttons.new_language" /></Link>
				</div>
				<Card className="fadeInLoadUp" >
					<Card.Body>
						<LanguagesTable />
					</Card.Body>
				</Card>
			</div>
		)
	}
}

LanguagePage.propTypes = {
	getLanguagesAction: PropTypes.func.isRequired,
	clients: PropTypes.shape({
		isLoading: PropTypes.bool,
		isExporting: PropTypes.bool,
		hasError: PropTypes.bool,
		filters: PropTypes.arrayOf(PropTypes.object),
		meta: PropTypes.shape({
			pagination: PropTypes.shape({
				current_page: PropTypes.number.isRequired
			})
		})
	}).isRequired
}

const mapStateToProps = (state) => ({
	clients: state.clients
})

export default connect(mapStateToProps, { getLanguagesAction })(LanguagePage)
